import { UNKNOWN_DIMENSION } from '../constants';

export enum ERoute {
  Map = 'map',
  MapNovostroyki = 'map-novostroyki',
  Other = 'other',
}

/**
 * Разрез метрик по маршруту (решение Q16): /map и /map-novostroyki отдаются одним бандлом,
 * но набор пинов и промо-логика у них разные, поэтому считаем их раздельно.
 */
export function getRoute(): string {
  if (typeof window === 'undefined') {
    return UNKNOWN_DIMENSION;
  }

  const { pathname } = window.location;

  /** Проверяем более длинный маршрут первым, иначе он попадёт в ветку /map */
  if (pathname.startsWith('/map-novostroyki')) {
    return ERoute.MapNovostroyki;
  }

  if (pathname.startsWith('/map')) {
    return ERoute.Map;
  }

  return ERoute.Other;
}
